export enum EEntityLinkCacheData {
	Add = "Add",
	Remove = "Remove"
}